"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGenerated = exports.T = exports.convertSVGtoBase64 = exports.remoteFormatsForAsset = exports.isRemoteVectorSet = exports.isFlag = exports.getFontAssetUrl = exports.getImageAssetUrl = exports.generateImageAssetFileName = exports.getImageSize = void 0;
var getImageSize_1 = require("./utilities/getImageSize");
Object.defineProperty(exports, "getImageSize", { enumerable: true, get: function () { return __importDefault(getImageSize_1).default; } });
var generateImageAssetFileName_1 = require("./utilities/generateImageAssetFileName");
Object.defineProperty(exports, "generateImageAssetFileName", { enumerable: true, get: function () { return __importDefault(generateImageAssetFileName_1).default; } });
var getImageAssetUrl_1 = require("./utilities/getImageAssetUrl");
Object.defineProperty(exports, "getImageAssetUrl", { enumerable: true, get: function () { return __importDefault(getImageAssetUrl_1).default; } });
var getFontAssetUrl_1 = require("./utilities/getFontAssetUrl");
Object.defineProperty(exports, "getFontAssetUrl", { enumerable: true, get: function () { return __importDefault(getFontAssetUrl_1).default; } });
var isFlagSet_1 = require("./utilities/isFlagSet");
Object.defineProperty(exports, "isFlag", { enumerable: true, get: function () { return __importDefault(isFlagSet_1).default; } });
var isRemoteVectorSet_1 = require("./utilities/isRemoteVectorSet");
Object.defineProperty(exports, "isRemoteVectorSet", { enumerable: true, get: function () { return __importDefault(isRemoteVectorSet_1).default; } });
var remoteFormatsForAsset_1 = require("./utilities/remoteFormatsForAsset");
Object.defineProperty(exports, "remoteFormatsForAsset", { enumerable: true, get: function () { return __importDefault(remoteFormatsForAsset_1).default; } });
var convertSVGtoBase64_1 = require("./utilities/convertSVGtoBase64");
Object.defineProperty(exports, "convertSVGtoBase64", { enumerable: true, get: function () { return __importDefault(convertSVGtoBase64_1).default; } });
exports.T = __importStar(require("./types"));
exports.TGenerated = __importStar(require("./types/generated"));
